import { class_type } from "../Docs/fable_modules/fable-library.3.7.1/Reflection.js";

export class Table {
    constructor() {
    }
}

export function Table$reflection() {
    return class_type("Feliz.TanStack.Table.Ordering.Table", void 0, Table);
}

export function Table_setColumnOrder(columnOrder, table) {
    table._obj.setColumnOrder(columnOrder);
    return table;
}

export function Table_resetColumnOrder_Z4395D14A(table) {
    table._obj.resetColumnOrder();
    return table;
}

//# sourceMappingURL=Ordering.fs.js.map
